import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const HIDDEN_ON = ["/deal-me-in", "/admin", "/contact"];

const StickyDealBar = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 560);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hidden = HIDDEN_ON.some((p) => location.pathname.startsWith(p));

  return (
    <AnimatePresence>
      {visible && !hidden && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 md:hidden"
          data-testid="sticky-deal-bar"
        >
          <div className="flex items-center justify-between gap-3 border-t border-brass/20 bg-charcoal/95 px-5 py-3 backdrop-blur-xl">
            <p className="text-[11px] leading-snug text-ivory/70">
              Join the Players List.
              <span className="block text-ivory/45">No obligation to attend.</span>
            </p>
            <Link
              to="/deal-me-in"
              data-testid="sticky-deal-me-in-button"
              className="inline-flex h-11 shrink-0 items-center rounded-xl bg-burgundy px-5 text-sm font-semibold text-ivory transition-colors hover:bg-[#a33847]"
            >
              Deal Me In
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyDealBar;
